import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loading = ({ message = "Loading..." }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '50vh', width: '100%' }}>
      <CircularProgress size={60} thickness={4} sx={{ mb: 2 }} />
      <Typography variant="h6" color="textSecondary">{message}</Typography>
    </Box>
  );
};

export default Loading;